import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  deleteCustomer,
  getCustomers,
} from "../../../../services/sales/customerService";
import CustomerForm from "./customerForm";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { whatsappChat } from "../../../../utils/utils";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";

function Customers({ history }) {
  const { reload } = useGlobalData();
  const [auth, setAuth] = useState({});
  const [open, setOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState({});
  const customerDetailColumn = [
    {
      header: "Contact Name",
      field: "contactName",
      type: "string",
    },
    {
      header: "Position",
      field: "position",
      type: "string",
    },
    {
      header: "Website",
      field: "website",
      type: "string",
    },
    {
      header: "Taxpayer Identification Number",
      field: "taxpayerID",
      type: "string",
    },
    {
      header: "Email",
      field: "contactEmail",
      type: "string",
    },
    {
      header: "Industry Type",
      field: "industryTypeName",
      type: "string",
    },
    {
      header: "Business Size",
      field: "businessSizeName",
      type: "string",
    },
    {
      header: "Source",
      field: "sourceName",
      type: "string",
    },
    {
      header: "Address",
      field: "address",
      type: "string",
    },
    {
      header: "Province / State",
      field: "province",
      type: "string",
    },
    {
      header: "Country",
      field: "countryName",
      type: "string",
    },
    {
      header: "Postal Code",
      field: "postalCode",
      type: "string",
    },
    {
      header: "Receivable Account",
      field: "receivableAccountName",
      type: "string",
    },
    {
      header: "Lead ID",
      field: "leadID",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  async function getCustomersData() {
    const response = await getCustomers();
    const { data, auth } = response.data;
    const { customers } = data;
    setOpen(false);
    setCustomers(customers);
    setAuth(auth);
  }
  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/menu");
    },
  });
  if (auth.create) {
    actionButtons.push({
      title: "New Customer",
      color: "primary",
      icon: "fas fa-plus-circle",
      onClick: () => {
        setCustomer({ ID: 0 });
        setOpen(true);
      },
    });
  }
  useEffect(() => {
    getCustomersData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Customer List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/customers",
            title: "Customers",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {customers.length ? (
          <CustomDataTable
            data={customers}
            dataDetailColumns={customerDetailColumn}
            onRefreshData={() => {
              getCustomersData();
            }}
            tableName="customer"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "Customer ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Customer Group",
                field: "customerGroupName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Customer Name",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Phone Number",
                field: "contactPhone",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.contactPhone}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "City",
                field: "city",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.addressPhone !== "" ? (
                      <BootstrapTooltip title="Whatsapp Chat Customer">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            whatsappChat(
                              rowData.addressPhone,
                              `Hi customer ${rowData.customerName}`
                            );
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="flaticon-whatsapp"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    <BootstrapTooltip title="Edit Customer">
                      <button
                        type="button"
                        onClick={(event) => {
                          setCustomer(rowData);
                          setOpen(true);
                        }}
                        className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Customer Detail">
                      <button
                        type="button"
                        onClick={() => {
                          history.push("/sales/customer-detail/" + rowData.ID);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Customer">
                      <button
                        type="button"
                        onClick={(event) => {
                          handleDeleteCustomer(rowData.ID);
                        }}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Sales.png"
            description="Hooray! You're ready to have your first Customer!"
            guidance="Hint: manage your customers for good quality services"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={open}
        title="Customer Form"
        onCloseDialog={() => {
          setOpen(false);
        }}
        maxWIdth="md"
      >
        <CustomerForm
          customer={customer}
          onCloseDialog={() => {
            setOpen(false);
          }}
          onReloadCustomers={() => {
            getCustomersData();
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleDeleteCustomer(customerID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Customer ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCustomer(customerID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getCustomersData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default Customers;
